export const NAVAS_N4_DICTIONARY: Record<string, { title: string; description: string }> = {
  "argo_ar_carrier_visit": {
    "title": "Argo Ar Carrier Visit",
    "description": "Records details about carrier visits"
  },
  "argo_ar_chargeable_appt_events": {
    "title": "Argo Ar Chargeable Appt Events",
    "description": "Tracks events related to chargeable appointments"
  },
  "argo_ar_chargeable_mrn_events": {
    "title": "Argo Ar Chargeable Mrn Events",
    "description": "Logs events associated with chargeable marine reference numbers"
  },
  "argo_ar_chargeable_unit_events": {
    "title": "Argo Ar Chargeable Unit Events",
    "description": "Details events involving chargeable units"
  },
  "argo_ar_guarantees": {
    "title": "Argo Ar Guarantees",
    "description": "Manages information about guarantees related to different operational aspects"
  },
  "argo_ar_property_source": {
    "title": "Argo Ar Property Source",
    "description": "Tracks sources of various properties used within the system"
  },
  "argo_ar_visit_details": {
    "title": "Argo Ar Visit Details",
    "description": "Contains detailed records of visits"
  },
  "argo_bizrole_priv": {
    "title": "Argo Bizrole Priv",
    "description": "Stores business role privileges"
  },
  "argo_business_group_businesses": {
    "title": "Argo Business Group Businesses",
    "description": "Maps business groups to individual businesses"
  },
  "argo_business_groups": {
    "title": "Argo Business Groups",
    "description": "Defines different business groups and their characteristics within the system."
  },
  "argo_cal_event": {
    "title": "Argo Cal Event",
    "description": "Records calendar events"
  },
  "argo_cal_event_type": {
    "title": "Argo Cal Event Type",
    "description": "Defines different types of calendar events"
  },
  "argo_calendar": {
    "title": "Argo Calendar",
    "description": "Holds overall calendar data"
  },
  "argo_carrier_visit": {
    "title": "Argo Carrier Visit",
    "description": "Details visits by carriers"
  },
  "argo_chargeable_appt_events": {
    "title": "Argo Chargeable Appt Events",
    "description": "Tracks events related to appointments that incur charges"
  },
  "argo_chargeable_marine_events": {
    "title": "Argo Chargeable Marine Events",
    "description": "Logs marine events that involve charges"
  },
  "argo_chargeable_unit_events": {
    "title": "Argo Chargeable Unit Events",
    "description": "Manages events involving chargeable units"
  },
  "argo_complex": {
    "title": "Argo Complex",
    "description": "Defines various operational complexes"
  },
  "argo_digital_assets": {
    "title": "Argo Digital Assets",
    "description": "Tracks digital assets within the system"
  },
  "argo_exchange_areas": {
    "title": "Argo Exchange Areas",
    "description": "Defines areas where exchanges occur"
  },
  "argo_exchange_lanes": {
    "title": "Argo Exchange Lanes",
    "description": "Manages lanes used for exchanges"
  },
  "argo_facility": {
    "title": "Argo Facility",
    "description": "Contains data about facilities"
  },
  "argo_facility_relays": {
    "title": "Argo Facility Relays",
    "description": "Tracks relay points within facilities"
  },
  "argo_general_reference": {
    "title": "Argo General Reference",
    "description": "Stores general reference data used across various modules of the system."
  },
  "argo_groovy_job_definition": {
    "title": "Argo Groovy Job Definition",
    "description": "Defines job tasks and schedules using Groovy scripts"
  },
  "argo_guarantees": {
    "title": "Argo Guarantees",
    "description": "Manages guarantee records"
  },
  "argo_integration_error": {
    "title": "Argo Integration Error",
    "description": "Logs errors encountered during system integrations"
  },
  "argo_job_step_projection": {
    "title": "Argo Job Step Projection",
    "description": "Tracks the projection of job steps"
  },
  "argo_lane_printers": {
    "title": "Argo Lane Printers",
    "description": "Records details about printers used in lanes"
  },
  "argo_lanes": {
    "title": "Argo Lanes",
    "description": "Defines lanes used in operations"
  },
  "argo_line_port_rules": {
    "title": "Argo Line Port Rules",
    "description": "Manages rules for line ports"
  },
  "argo_lock_types": {
    "title": "Argo Lock Types",
    "description": "Defines various types of locks used within the system"
  },
  "argo_locks": {
    "title": "Argo Locks",
    "description": "Tracks individual locks"
  },
  "argo_mock_visit": {
    "title": "Argo Mock Visit",
    "description": "Records mock visits used for testing or training purposes"
  },
  "argo_operator": {
    "title": "Argo Operator",
    "description": "Stores data about operators"
  },
  "argo_portal": {
    "title": "Argo Portal",
    "description": "Defines the system's portal"
  },
  "argo_property_source": {
    "title": "Argo Property Source",
    "description": "Manages sources of various properties"
  },
  "argo_purged_failed_entities": {
    "title": "Argo Purged Failed Entities",
    "description": "Tracks entities that have been purged due to failures"
  },
  "argo_quay": {
    "title": "Argo Quay",
    "description": "Contains data about quays"
  },
  "argo_repjob_reportdef_mapping": {
    "title": "Argo Repjob Reportdef Mapping",
    "description": "Maps report definitions to jobs"
  },
  "argo_report_definitions": {
    "title": "Argo Report Definitions",
    "description": "Defines various report templates and structures used in the system."
  },
  "argo_report_defn_roles_map": {
    "title": "Argo Report Defn Roles Map",
    "description": "Maps report definitions to roles"
  },
  "argo_report_designs": {
    "title": "Argo Report Designs",
    "description": "Details the design of reports"
  },
  "argo_report_job_definition": {
    "title": "Argo Report Job Definition",
    "description": "Defines the jobs associated with generating reports"
  },
  "argo_report_output": {
    "title": "Argo Report Output",
    "description": "Tracks the output of generated reports"
  },
  "argo_reportable_entity": {
    "title": "Argo Reportable Entity",
    "description": "Defines entities that can be reported on"
  },
  "argo_reportable_field": {
    "title": "Argo Reportable Field",
    "description": "Tracks fields that can be included in reports"
  },
  "argo_sequences": {
    "title": "Argo Sequences",
    "description": "Manages sequences used for generating unique identifiers or ordering data."
  },
  "argo_user_key_set": {
    "title": "Argo User Key Set",
    "description": "Stores sets of keys associated with users"
  },
  "argo_user_prefs": {
    "title": "Argo User Prefs",
    "description": "Records user preferences"
  },
  "argo_visit_details": {
    "title": "Argo Visit Details",
    "description": "Details the visits logged in the system"
  },
  "argo_webservice_log_entries": {
    "title": "Argo Webservice Log Entries",
    "description": "Tracks log entries from web services"
  },
  "argo_workstation_card_readers": {
    "title": "Argo Workstation Card Readers",
    "description": "Details card readers used at workstations"
  },
  "argo_yard": {
    "title": "Argo Yard",
    "description": "Contains data about yards"
  },
  "argo_yard_block_supplement": {
    "title": "Argo Yard Block Supplement",
    "description": "Records supplements for yard blocks"
  },
  "argo_yard_shared_block": {
    "title": "Argo Yard Shared Block",
    "description": "Tracks shared blocks within yards"
  },
  "base_user": {
    "title": "Base User",
    "description": "Contains information about users within the system"
  },
  "config_form_fields": {
    "title": "Config Form Fields",
    "description": "Stores metadata about form fields used in system configurations"
  },
  "config_forms": {
    "title": "Config Forms",
    "description": "Manages the definitions of various forms used in the system"
  },
  "config_metafield_lov": {
    "title": "Config Metafield Lov",
    "description": "Defines lists of values for metadata fields"
  },
  "config_metafield_override": {
    "title": "Config Metafield Override",
    "description": "Tracks overrides for metadata field configurations"
  },
  "config_resource_bundle": {
    "title": "Config Resource Bundle",
    "description": "Manages bundles of resources used in system configurations"
  },
  "config_settings": {
    "title": "Config Settings",
    "description": "Contains system-wide configuration settings"
  },
  "config_string_resource": {
    "title": "Config String Resource",
    "description": "Stores string resources for localization and user interface text"
  },
  "config_variform": {
    "title": "Config Variform",
    "description": "Defines variable forms used in the system"
  },
  "crg_ar_bills_of_lading": {
    "title": "Crg Ar Bills Of Lading",
    "description": "Records details of accounts receivable bills of lading"
  },
  "crg_ar_bl_item": {
    "title": "Crg Ar Bl Item",
    "description": "Tracks items listed on accounts receivable bills of lading"
  },
  "crg_ar_bl_release": {
    "title": "Crg Ar Bl Release",
    "description": "Manages releases of accounts receivable bills of lading"
  },
  "crg_ar_damages": {
    "title": "Crg Ar Damages",
    "description": "Logs damage claims related to accounts receivable shipments"
  },
  "crg_ar_goods_bls": {
    "title": "Crg Ar Goods Bls",
    "description": "Tracks goods associated with accounts receivable bills of lading"
  },
  "crg_ar_lots": {
    "title": "Crg Ar Lots",
    "description": "Records lots associated with accounts receivable transactions"
  },
  "crg_bills_of_lading": {
    "title": "Crg Bills Of Lading",
    "description": "Contains data on bills of lading"
  },
  "crg_bl_goods": {
    "title": "Crg Bl Goods",
    "description": "Details goods listed on bills of lading"
  },
  "crg_bl_item": {
    "title": "Crg Bl Item",
    "description": "Records items listed on bills of lading"
  },
  "crg_bl_release": {
    "title": "Crg Bl Release",
    "description": "Manages the release of bills of lading"
  },
  "crg_damage_types": {
    "title": "Crg Damage Types",
    "description": "Defines various types of damages that can occur during shipping"
  },
  "crg_damages": {
    "title": "Crg Damages",
    "description": "Tracks recorded damages in shipments"
  },
  "crg_goods_bls": {
    "title": "Crg Goods Bls",
    "description": "Details the goods associated with bills of lading"
  },
  "crg_lots": {
    "title": "Crg Lots",
    "description": "Records lots associated with bills of lading and other transactions"
  },
  "crg_package_type": {
    "title": "Crg Package Type",
    "description": "Defines different types of packages used in shipments"
  },
  "crg_product_type": {
    "title": "Crg Product Type",
    "description": "Tracks types of products"
  },
  "ctl_asc_move_step": {
    "title": "Ctl Asc Move Step",
    "description": "Manages steps involved in advanced step control moves"
  },
  "ctl_asc_moves": {
    "title": "Ctl Asc Moves",
    "description": "Records advanced step control moves"
  },
  "ctl_drive_instruction": {
    "title": "Ctl Drive Instruction",
    "description": "Tracks instructions for driving operations"
  },
  "ctl_job_step_configuration": {
    "title": "Ctl Job Step Configuration",
    "description": "Defines configurations for job steps"
  },
  "ctl_transfer_time_history": {
    "title": "Ctl Transfer Time History",
    "description": "Logs historical data on transfer times"
  },
  "CUSTOM_PREAN_VALIDATION_ERROR": {
    "title": "Custom Prean Validation Error",
    "description": "Records errors encountered during custom pre-analysis validation"
  },
  "edi_batch": {
    "title": "Edi Batch",
    "description": "Tracks EDI (Electronic Data Interchange) batches"
  },
  "edi_batch_process": {
    "title": "Edi Batch Process",
    "description": "Manages the processing of EDI batches"
  },
  "edi_error": {
    "title": "Edi Error",
    "description": "Logs errors encountered during EDI transactions"
  },
  "edi_event": {
    "title": "Edi Event",
    "description": "Records EDI events"
  },
  "edi_filter": {
    "title": "Edi Filter",
    "description": "Defines filters used for processing EDI data"
  },
  "edi_filter_entry": {
    "title": "Edi Filter Entry",
    "description": "Tracks entries in EDI filters"
  },
  "edi_interchange": {
    "title": "Edi Interchange",
    "description": "Manages EDI interchange data"
  },
  "edi_job_definition": {
    "title": "Edi Job Definition",
    "description": "Defines EDI job configurations"
  },
  "edi_job_schedule": {
    "title": "Edi Job Schedule",
    "description": "Tracks schedules for EDI jobs"
  },
  "edi_mailbox": {
    "title": "Edi Mailbox",
    "description": "Records details of EDI mailboxes used for exchanging data"
  },
  "edi_message_map": {
    "title": "Edi Message Map",
    "description": "Manages mappings of EDI messages"
  },
  "edi_message_type": {
    "title": "Edi Message Type",
    "description": "Defines types of EDI messages"
  },
  "edi_posting_rules": {
    "title": "Edi Posting Rules",
    "description": "Tracks rules for posting EDI transactions"
  },
  "edi_queued_interchange": {
    "title": "Edi Queued Interchange",
    "description": "Logs interchanges queued for EDI processing"
  },
  "edi_rel_dep_codes_map": {
    "title": "Edi Rel Dep Codes Map",
    "description": "Manages relationships between EDI codes and dependencies"
  },
  "edi_release_maps": {
    "title": "Edi Release Maps",
    "description": "Defines release maps for EDI data"
  },
  "edi_sample": {
    "title": "Edi Sample",
    "description": "Records sample EDI transactions"
  },
  "edi_segment": {
    "title": "Edi Segment",
    "description": "Tracks segments of EDI messages"
  },
  "edi_session": {
    "title": "Edi Session",
    "description": "Manages EDI sessions"
  },
  "edi_session_filter": {
    "title": "Edi Session Filter",
    "description": "Defines filters applied to EDI sessions"
  },
  "edi_session_mailbox": {
    "title": "Edi Session Mailbox",
    "description": "Tracks mailboxes used during EDI sessions"
  },
  "edi_setting": {
    "title": "Edi Setting",
    "description": "Records settings related to EDI processing"
  },
  "edi_trading_partners": {
    "title": "Edi Trading Partners",
    "description": "Manages information about EDI trading partners"
  },
  "edi_transaction": {
    "title": "Edi Transaction",
    "description": "Logs individual EDI transactions"
  },
  "edi_transaction_keyword": {
    "title": "Edi Transaction Keyword",
    "description": "Tracks keywords associated with EDI transactions"
  },
  "esb_config": {
    "title": "Esb Config",
    "description": "Defines configurations for Enterprise Service Bus (ESB) operations"
  },
  "EventTypes": {
    "title": "Eventtypes",
    "description": "Tracks types of events within the system"
  },
  "ext_mod_entity": {
    "title": "Ext Mod Entity",
    "description": "Manages external module entities"
  },
  "ext_mod_entity_custom": {
    "title": "Ext Mod Entity Custom",
    "description": "Records custom configurations for external module entities"
  },
  "ext_mod_entity_system": {
    "title": "Ext Mod Entity System",
    "description": "Tracks system-level details for external module entities"
  },
  "ext_mod_field": {
    "title": "Ext Mod Field",
    "description": "Defines fields for external modules"
  },
  "ext_mod_field_version": {
    "title": "Ext Mod Field Version",
    "description": "Records versions of fields used in external modules"
  },
  "ext_persistence_event": {
    "title": "Ext Persistence Event",
    "description": "Logs events related to external module persistence"
  },
  "ext_persistence_event_details": {
    "title": "Ext Persistence Event Details",
    "description": "Tracks detailed information about external module persistence events"
  },
  "ext_snapshot": {
    "title": "Ext Snapshot",
    "description": "Records snapshots of external module states"
  },
  "ext_snapshot_item": {
    "title": "Ext Snapshot Item",
    "description": "Manages items within external module snapshots"
  },
  "frm_announcement": {
    "title": "Frm Announcement",
    "description": "Contains announcements related to the system"
  },
  "frm_announcements_mapping": {
    "title": "Frm Announcements Mapping",
    "description": "Tracks mappings between announcements and their associated users or groups."
  },
  "frm_application_log": {
    "title": "Frm Application Log",
    "description": "Records application logs for monitoring and debugging"
  },
  "frm_cal_event": {
    "title": "Frm Cal Event",
    "description": "Manages calendar events"
  },
  "frm_cal_event_type": {
    "title": "Frm Cal Event Type",
    "description": "Defines types of calendar events"
  },
  "frm_carina_dual": {
    "title": "Frm Carina Dual",
    "description": "Tracks dual system configurations for Carina"
  },
  "frm_cluster_service": {
    "title": "Frm Cluster Service",
    "description": "Manages services related to clustered environments"
  },
  "frm_component_event": {
    "title": "Frm Component Event",
    "description": "Records events related to system components"
  },
  "frm_component_event_log": {
    "title": "Frm Component Event Log",
    "description": "Tracks logs of component events"
  },
  "frm_custom_node": {
    "title": "Frm Custom Node",
    "description": "Defines custom nodes in the system"
  },
  "frm_dashboard": {
    "title": "Frm Dashboard",
    "description": "Manages dashboard settings and configurations"
  },
  "frm_extension": {
    "title": "Frm Extension",
    "description": "Tracks system extensions"
  },
  "frm_extension_auditor": {
    "title": "Frm Extension Auditor",
    "description": "Records audit logs related to system extensions"
  },
  "frm_extension_injection": {
    "title": "Frm Extension Injection",
    "description": "Manages injection points for extensions"
  },
  "frm_gadget": {
    "title": "Frm Gadget",
    "description": "Defines gadgets or widgets used in the system"
  },
  "frm_gadget_default_props": {
    "title": "Frm Gadget Default Props",
    "description": "Records default properties for gadgets"
  },
  "frm_gadget_defaults": {
    "title": "Frm Gadget Defaults",
    "description": "Tracks default settings for various system gadgets"
  },
  "frm_gadget_property": {
    "title": "Frm Gadget Property",
    "description": "Manages properties of gadgets"
  },
  "frm_integration_service": {
    "title": "Frm Integration Service",
    "description": "Records details of services related to system integration"
  },
  "frm_job_definition": {
    "title": "Frm Job Definition",
    "description": "Defines job configurations"
  },
  "frm_job_group": {
    "title": "Frm Job Group",
    "description": "Manages groups of jobs"
  },
  "frm_job_group_node": {
    "title": "Frm Job Group Node",
    "description": "Tracks nodes within job groups"
  },
  "frm_job_log": {
    "title": "Frm Job Log",
    "description": "Records logs of job executions"
  },
  "frm_job_month_day": {
    "title": "Frm Job Month Day",
    "description": "Manages job schedules based on month and day"
  },
  "frm_job_weekday": {
    "title": "Frm Job Weekday",
    "description": "Defines job schedules based on weekdays"
  },
  "frm_license": {
    "title": "Frm License",
    "description": "Tracks system licenses"
  },
  "frm_mapping_predicates": {
    "title": "Frm Mapping Predicates",
    "description": "Defines predicates for data mappings"
  },
  "frm_mapping_values": {
    "title": "Frm Mapping Values",
    "description": "Records values associated with data mappings"
  },
  "frm_module_versions": {
    "title": "Frm Module Versions",
    "description": "Manages versions of system modules"
  },
  "frm_node_config": {
    "title": "Frm Node Config",
    "description": "Tracks configurations for system nodes"
  },
  "frm_upgrade_action_history": {
    "title": "Frm Upgrade Action History",
    "description": "Records history of upgrade actions"
  },
  "frm_upgrade_log": {
    "title": "Frm Upgrade Log",
    "description": "Logs details of system upgrades"
  },
  "groovy_job_definition": {
    "title": "Groovy Job Definition",
    "description": "Defines Groovy script jobs"
  },
  "grvjob_grvplugin_mapping": {
    "title": "Grvjob Grvplugin Mapping",
    "description": "Tracks mappings between Groovy jobs and plugins"
  },
  "inv_ar_eq_base_order": {
    "title": "Inv Ar Eq Base Order",
    "description": "Records base orders for accounts receivable equipment"
  },
  "inv_ar_eq_base_order_item": {
    "title": "Inv Ar Eq Base Order Item",
    "description": "Tracks items within accounts receivable base orders"
  },
  "inv_ar_goods": {
    "title": "Inv Ar Goods",
    "description": "Manages goods related to accounts receivable"
  },
  "inv_ar_goods_declaration": {
    "title": "Inv Ar Goods Declaration",
    "description": "Records declarations for accounts receivable goods"
  },
  "inv_ar_goods_documents": {
    "title": "Inv Ar Goods Documents",
    "description": "Tracks documents related to accounts receivable goods"
  },
  "inv_ar_hazard_items": {
    "title": "Inv Ar Hazard Items",
    "description": "Manages hazardous items in accounts receivable"
  },
  "inv_ar_hazards": {
    "title": "Inv Ar Hazards",
    "description": "Records hazardous materials in accounts receivable"
  },
  "inv_ar_import_delivery_orders": {
    "title": "Inv Ar Import Delivery Orders",
    "description": "Tracks import delivery orders for accounts receivable"
  },
  "inv_ar_move_event": {
    "title": "Inv Ar Move Event",
    "description": "Records events related to the movement of accounts receivable inventory"
  },
  "inv_ar_unit": {
    "title": "Inv Ar Unit",
    "description": "Manages accounts receivable units"
  },
  "inv_ar_unit_equip": {
    "title": "Inv Ar Unit Equip",
    "description": "Tracks equipment associated with accounts receivable units"
  },
  "inv_ar_unit_equip_damage_item": {
    "title": "Inv Ar Unit Equip Damage Item",
    "description": "Records damage items for equipment associated with accounts receivable units"
  },
  "inv_ar_unit_equip_damages": {
    "title": "Inv Ar Unit Equip Damages",
    "description": "Manages records of equipment damages for accounts receivable units"
  },
  "inv_ar_unit_fcy_visit": {
    "title": "Inv Ar Unit Fcy Visit",
    "description": "Tracks foreign currency visits related to accounts receivable units"
  },
  "inv_ar_unit_observed_pacards": {
    "title": "Inv Ar Unit Observed Pacards",
    "description": "Records observed placards for accounts receivable units"
  },
  "inv_ar_unit_reefer_records": {
    "title": "Inv Ar Unit Reefer Records",
    "description": "Manages reefer records for accounts receivable units"
  },
  "inv_ar_unit_yrd_visit": {
    "title": "Inv Ar Unit Yrd Visit",
    "description": "Tracks yard visits related to accounts receivable units"
  },
  "inv_eq_base_order": {
    "title": "Inv Eq Base Order",
    "description": "Records base orders for equipment inventory"
  },
  "inv_eq_base_order_item": {
    "title": "Inv Eq Base Order Item",
    "description": "Tracks items within equipment base orders"
  },
  "inv_eq_state": {
    "title": "Inv Eq State",
    "description": "Manages states of equipment"
  },
  "inv_goods": {
    "title": "Inv Goods",
    "description": "Records details of goods in inventory"
  },
  "inv_goods_declaration": {
    "title": "Inv Goods Declaration",
    "description": "Manages declarations for inventory goods"
  },
  "inv_goods_documents": {
    "title": "Inv Goods Documents",
    "description": "Tracks documents related to inventory goods"
  },
  "inv_hazard_fire_code": {
    "title": "Inv Hazard Fire Code",
    "description": "Defines fire codes for hazardous materials"
  },
  "inv_hazard_item_placards": {
    "title": "Inv Hazard Item Placards",
    "description": "Records placards for hazardous items"
  },
  "inv_hazard_items": {
    "title": "Inv Hazard Items",
    "description": "Manages hazardous items in inventory"
  },
  "inv_hazards": {
    "title": "Inv Hazards",
    "description": "Tracks hazards associated with inventory items"
  },
  "inv_import_delivery_orders": {
    "title": "Inv Import Delivery Orders",
    "description": "Records import delivery orders"
  },
  "inv_move_event": {
    "title": "Inv Move Event",
    "description": "Manages events related to inventory movement"
  },
  "inv_pool_equipment": {
    "title": "Inv Pool Equipment",
    "description": "Tracks equipment in inventory pools"
  },
  "inv_pool_member_equip_classes": {
    "title": "Inv Pool Member Equip Classes",
    "description": "Defines equipment classes for inventory pools"
  },
  "inv_pool_member_equip_type": {
    "title": "Inv Pool Member Equip Type",
    "description": "Manages types of equipment in inventory pools"
  },
  "inv_pool_members": {
    "title": "Inv Pool Members",
    "description": "Records members of inventory pools"
  },
  "inv_pool_truck_co": {
    "title": "Inv Pool Truck Co",
    "description": "Tracks truck companies associated with inventory pools"
  },
  "inv_pools": {
    "title": "Inv Pools",
    "description": "Manages inventory pools"
  },
  "inv_storage_rule": {
    "title": "Inv Storage Rule",
    "description": "Defines rules for inventory storage"
  },
  "inv_tbd_unit": {
    "title": "Inv Tbd Unit",
    "description": "Records units pending further details or categorization"
  },
  "inv_unit": {
    "title": "Inv Unit",
    "description": "Manages inventory units"
  },
  "inv_unit_equip": {
    "title": "Inv Unit Equip",
    "description": "Tracks equipment associated with inventory units"
  },
  "inv_unit_equip_damage_item": {
    "title": "Inv Unit Equip Damage Item",
    "description": "Records damage items for equipment associated with inventory units"
  },
  "inv_unit_equip_damages": {
    "title": "Inv Unit Equip Damages",
    "description": "Manages records of equipment damages for inventory units"
  },
  "inv_unit_fcy_visit": {
    "title": "Inv Unit Fcy Visit",
    "description": "Tracks foreign currency visits related to inventory units"
  },
  "inv_unit_observed_pacards": {
    "title": "Inv Unit Observed Pacards",
    "description": "Records observed placards for inventory units"
  },
  "inv_unit_reefer_records": {
    "title": "Inv Unit Reefer Records",
    "description": "Manages reefer records for inventory units"
  },
  "inv_unit_yrd_visit": {
    "title": "Inv Unit Yrd Visit",
    "description": "Tracks yard visits related to inventory units"
  },
  "inv_wi": {
    "title": "Inv Wi",
    "description": "Records warehouse inventory details"
  },
  "inv_wq": {
    "title": "Inv Wq",
    "description": "Manages warehouse queues"
  },
  "mns_ar_carrier_statistics": {
    "title": "Mns Ar Carrier Statistics",
    "description": "Tracks statistics for accounts receivable carriers"
  },
  "mns_ar_carrier_visit": {
    "title": "Mns Ar Carrier Visit",
    "description": "Records visits by accounts receivable carriers"
  },
  "mns_ar_che_move_statistics": {
    "title": "Mns Ar Che Move Statistics",
    "description": "Manages statistics for accounts receivable che moves"
  },
  "mns_ar_che_operator_statistics": {
    "title": "Mns Ar Che Operator Statistics",
    "description": "Tracks statistics for accounts receivable che operators"
  },
  "mns_ar_che_session": {
    "title": "Mns Ar Che Session",
    "description": "Records sessions related to accounts receivable che"
  },
  "mns_ar_che_session_period": {
    "title": "Mns Ar Che Session Period",
    "description": "Tracks periods within accounts receivable che sessions"
  },
  "mns_ar_che_trip_statistics": {
    "title": "Mns Ar Che Trip Statistics",
    "description": "Manages statistics for trips involving accounts receivable che"
  },
  "mns_ar_crane_activity": {
    "title": "Mns Ar Crane Activity",
    "description": "Records activity related to cranes in accounts receivable operations"
  },
  "mns_ar_equipment_block_visit": {
    "title": "Mns Ar Equipment Block Visit",
    "description": "Tracks visits to equipment blocks in accounts receivable operations"
  },
  "mns_ar_move_record": {
    "title": "Mns Ar Move Record",
    "description": "Records movements in accounts receivable operations"
  },
  "mns_ar_secondary_statistics": {
    "title": "Mns Ar Secondary Statistics",
    "description": "Tracks secondary statistics in accounts receivable operations"
  },
  "mns_ar_vessel_crane_statistics": {
    "title": "Mns Ar Vessel Crane Statistics",
    "description": "Manages statistics for vessel cranes in accounts receivable operations"
  },
  "mns_ar_vessel_visit_statistics": {
    "title": "Mns Ar Vessel Visit Statistics",
    "description": "Records visit statistics for vessels in accounts receivable operations"
  },
  "mns_ar_yard_block_statistics": {
    "title": "Mns Ar Yard Block Statistics",
    "description": "Tracks statistics for yard blocks in accounts receivable operations"
  },
  "mns_ar_yard_tier_statistics": {
    "title": "Mns Ar Yard Tier Statistics",
    "description": "Manages statistics for yard tiers in accounts receivable operations"
  },
  "mns_carrier_statistics": {
    "title": "Mns Carrier Statistics",
    "description": "Records carrier statistics"
  },
  "mns_che_move_statistics": {
    "title": "Mns Che Move Statistics",
    "description": "Tracks statistics for che moves"
  },
  "mns_che_operator_statistics": {
    "title": "Mns Che Operator Statistics",
    "description": "Manages statistics for che operators"
  },
  "mns_che_session": {
    "title": "Mns Che Session",
    "description": "Records sessions related to che"
  },
  "mns_che_session_period": {
    "title": "Mns Che Session Period",
    "description": "Tracks periods within che sessions"
  },
  "mns_che_trip_statistics": {
    "title": "Mns Che Trip Statistics",
    "description": "Manages statistics for trips involving che"
  },
  "mns_crane_activity": {
    "title": "Mns Crane Activity",
    "description": "Records crane activity"
  },
  "mns_crane_activity_set": {
    "title": "Mns Crane Activity Set",
    "description": "Tracks sets of crane activities"
  },
  "mns_equipment_block_visit": {
    "title": "Mns Equipment Block Visit",
    "description": "Records visits to equipment blocks"
  },
  "mns_move_record": {
    "title": "Mns Move Record",
    "description": "Manages records of equipment moves"
  },
  "mns_move_record_set": {
    "title": "Mns Move Record Set",
    "description": "Tracks sets of equipment move records"
  },
  "mns_ref_activity_code": {
    "title": "Mns Ref Activity Code",
    "description": "Defines reference codes for activities"
  },
  "mns_secondary_statistics": {
    "title": "Mns Secondary Statistics",
    "description": "Records secondary statistics related to equipment and operations"
  },
  "mns_vessel_crane_statistics": {
    "title": "Mns Vessel Crane Statistics",
    "description": "Manages statistics for vessel cranes"
  },
  "mns_vessel_visit_statistics": {
    "title": "Mns Vessel Visit Statistics",
    "description": "Tracks visit statistics for vessels"
  },
  "mns_yard_area_code": {
    "title": "Mns Yard Area Code",
    "description": "Defines area codes for yard management"
  },
  "mns_yard_block": {
    "title": "Mns Yard Block",
    "description": "Records yard blocks"
  },
  "mns_yard_block_statistics": {
    "title": "Mns Yard Block Statistics",
    "description": "Tracks statistics for yard blocks"
  },
  "mns_yard_tier_statistics": {
    "title": "Mns Yard Tier Statistics",
    "description": "Manages statistics for yard tiers"
  },
  "NodeInstanceLog": {
    "title": "Nodeinstancelog",
    "description": "Tracks logs for individual node instances"
  },
  "opt_job_configurations": {
    "title": "Opt Job Configurations",
    "description": "Manages job configurations"
  },
  "opt_problem_solution": {
    "title": "Opt Problem Solution",
    "description": "Records solutions for identified problems"
  },
  "opt_problem_type": {
    "title": "Opt Problem Type",
    "description": "Defines types of problems encountered"
  },
  "ord_ar_equipment_order_items": {
    "title": "Ord Ar Equipment Order Items",
    "description": "Tracks items within accounts receivable equipment orders"
  },
  "ord_cargo_srv_order_address": {
    "title": "Ord Cargo Srv Order Address",
    "description": "Records addresses related to cargo service orders"
  },
  "ord_cargo_srv_order_item": {
    "title": "Ord Cargo Srv Order Item",
    "description": "Manages items within cargo service orders"
  },
  "ord_carrier_visit_service_type": {
    "title": "Ord Carrier Visit Service Type",
    "description": "Defines service types associated with carrier visits"
  },
  "ord_eq_type_group_items": {
    "title": "Ord Eq Type Group Items",
    "description": "Tracks items within equipment type groups"
  },
  "ord_eq_type_groups": {
    "title": "Ord Eq Type Groups",
    "description": "Manages groups of equipment types"
  },
  "ord_equipment_order_items": {
    "title": "Ord Equipment Order Items",
    "description": "Records items within equipment orders"
  },
  "ord_item_service_type": {
    "title": "Ord Item Service Type",
    "description": "Defines service types for items"
  },
  "ord_item_service_unit": {
    "title": "Ord Item Service Unit",
    "description": "Manages service units for items"
  },
  "ord_service_order": {
    "title": "Ord Service Order",
    "description": "Tracks service orders"
  },
  "ord_service_order_item": {
    "title": "Ord Service Order Item",
    "description": "Records items within service orders"
  },
  "org_group": {
    "title": "Org Group",
    "description": "Defines organizational groups"
  },
  "org_group_org_map": {
    "title": "Org Group Org Map",
    "description": "Tracks mappings between organizational groups and organizations"
  },
  "organization": {
    "title": "Organization",
    "description": "Records information about organizations"
  },
  "ProcessInstanceInfo": {
    "title": "Processinstanceinfo",
    "description": "Manages information about process instances"
  },
  "ProcessInstanceLog": {
    "title": "Processinstancelog",
    "description": "Records logs related to process instances"
  },
  "qrtz_blob_triggers": {
    "title": "Qrtz Blob Triggers",
    "description": "Defines blob triggers for Quartz Scheduler"
  },
  "qrtz_calendars": {
    "title": "Qrtz Calendars",
    "description": "Manages Quartz Scheduler calendars"
  },
  "qrtz_cron_triggers": {
    "title": "Qrtz Cron Triggers",
    "description": "Records cron triggers for Quartz Scheduler"
  },
  "qrtz_fired_triggers": {
    "title": "Qrtz Fired Triggers",
    "description": "Tracks fired triggers in Quartz Scheduler"
  },
  "qrtz_job_details": {
    "title": "Qrtz Job Details",
    "description": "Manages details of Quartz Scheduler jobs"
  },
  "qrtz_locks": {
    "title": "Qrtz Locks",
    "description": "Records locks used by Quartz Scheduler to manage concurrent job executions."
  },
  "qrtz_paused_trigger_grps": {
    "title": "Qrtz Paused Trigger Grps",
    "description": "Tracks groups of paused triggers in Quartz Scheduler"
  },
  "qrtz_scheduler_state": {
    "title": "Qrtz Scheduler State",
    "description": "Records state information for Quartz Scheduler"
  },
  "qrtz_simple_triggers": {
    "title": "Qrtz Simple Triggers",
    "description": "Defines simple triggers for Quartz Scheduler"
  },
  "qrtz_simprop_triggers": {
    "title": "Qrtz Simprop Triggers",
    "description": "Manages triggers with simple properties for Quartz Scheduler"
  },
  "qrtz_triggers": {
    "title": "Qrtz Triggers",
    "description": "Records details of all Quartz Scheduler triggers"
  },
  "rail_ar_car_visits": {
    "title": "Rail Ar Car Visits",
    "description": "Tracks visits related to accounts receivable rail cars"
  },
  "rail_ar_cars": {
    "title": "Rail Ar Cars",
    "description": "Records information about accounts receivable rail cars"
  },
  "rail_ar_train_visit_details": {
    "title": "Rail Ar Train Visit Details",
    "description": "Manages details of train visits in accounts receivable"
  },
  "rail_car_platforms": {
    "title": "Rail Car Platforms",
    "description": "Defines platforms for rail cars"
  },
  "rail_car_states": {
    "title": "Rail Car States",
    "description": "Records states of rail cars"
  },
  "rail_car_type_platforms": {
    "title": "Rail Car Type Platforms",
    "description": "Tracks platforms associated with different types of rail cars"
  },
  "rail_car_types": {
    "title": "Rail Car Types",
    "description": "Defines types of rail cars"
  },
  "rail_car_visits": {
    "title": "Rail Car Visits",
    "description": "Records visits of rail cars"
  },
  "rail_cars": {
    "title": "Rail Cars",
    "description": "Manages information about rail cars"
  },
  "rail_railroads": {
    "title": "Rail Railroads",
    "description": "Records details about railroads"
  },
  "rail_route_restrictions": {
    "title": "Rail Route Restrictions",
    "description": "Defines restrictions on rail routes"
  },
  "rail_train_visit_details": {
    "title": "Rail Train Visit Details",
    "description": "Manages details of train visits"
  },
  "ref_agent": {
    "title": "Ref Agent",
    "description": "Records details about agents"
  },
  "ref_agent_representation": {
    "title": "Ref Agent Representation",
    "description": "Tracks representations of agents"
  },
  "ref_bizunit_master": {
    "title": "Ref Bizunit Master",
    "description": "Defines master records for business units"
  },
  "ref_bizunit_scoped": {
    "title": "Ref Bizunit Scoped",
    "description": "Records scoped business unit information"
  },
  "ref_bzu_grp_map": {
    "title": "Ref Bzu Grp Map",
    "description": "Tracks mappings between business unit groups"
  },
  "ref_carrier_itinerary": {
    "title": "Ref Carrier Itinerary",
    "description": "Records itineraries for carriers"
  },
  "ref_carrier_service": {
    "title": "Ref Carrier Service",
    "description": "Defines services offered by carriers"
  },
  "ref_commodity": {
    "title": "Ref Commodity",
    "description": "Records information about commodities"
  },
  "ref_country": {
    "title": "Ref Country",
    "description": "Defines countries"
  },
  "ref_crane_delay_types": {
    "title": "Ref Crane Delay Types",
    "description": "Tracks types of crane delays"
  },
  "ref_data_quality": {
    "title": "Ref Data Quality",
    "description": "Manages data quality metrics"
  },
  "ref_destination": {
    "title": "Ref Destination",
    "description": "Records destinations"
  },
  "ref_entity_set": {
    "title": "Ref Entity Set",
    "description": "Defines sets of entities"
  },
  "ref_entity_set_use": {
    "title": "Ref Entity Set Use",
    "description": "Tracks usage of entity sets"
  },
  "ref_eq_components": {
    "title": "Ref Eq Components",
    "description": "Records components of equipment"
  },
  "ref_equip_conditions": {
    "title": "Ref Equip Conditions",
    "description": "Defines conditions of equipment"
  },
  "ref_equip_damage_types": {
    "title": "Ref Equip Damage Types",
    "description": "Tracks types of equipment damage"
  },
  "ref_equip_features": {
    "title": "Ref Equip Features",
    "description": "Records features of equipment"
  },
  "ref_equip_grades": {
    "title": "Ref Equip Grades",
    "description": "Defines grades of equipment"
  },
  "ref_equip_prefixes": {
    "title": "Ref Equip Prefixes",
    "description": "Records prefixes used for equipment identification"
  },
  "ref_equip_serial_range": {
    "title": "Ref Equip Serial Range",
    "description": "Tracks serial number ranges for equipment"
  },
  "ref_equip_type": {
    "title": "Ref Equip Type",
    "description": "Defines types of equipment"
  },
  "ref_equipment": {
    "title": "Ref Equipment",
    "description": "Records general information about equipment"
  },
  "ref_groups": {
    "title": "Ref Groups",
    "description": "Defines various groups"
  },
  "ref_imdg_goods": {
    "title": "Ref Imdg Goods",
    "description": "Records goods classified under the IMDG code"
  },
  "ref_imdg_risks": {
    "title": "Ref Imdg Risks",
    "description": "Tracks risks associated with IMDG goods"
  },
  "ref_line_operator": {
    "title": "Ref Line Operator",
    "description": "Defines line operators"
  },
  "ref_mnr_status": {
    "title": "Ref Mnr Status",
    "description": "Records statuses for MNR (Movement Notification Report) items"
  },
  "ref_mock_biz_unit": {
    "title": "Ref Mock Biz Unit",
    "description": "Tracks mock business units"
  },
  "ref_order_purpose": {
    "title": "Ref Order Purpose",
    "description": "Defines purposes of orders"
  },
  "ref_placards": {
    "title": "Ref Placards",
    "description": "Records information about placards"
  },
  "ref_point_calls": {
    "title": "Ref Point Calls",
    "description": "Tracks point calls"
  },
  "ref_routing_point": {
    "title": "Ref Routing Point",
    "description": "Defines routing points"
  },
  "ref_shipper": {
    "title": "Ref Shipper",
    "description": "Records information about shippers"
  },
  "ref_snx_mailbox": {
    "title": "Ref Snx Mailbox",
    "description": "Manages information about SNX mailboxes"
  },
  "ref_special_stows": {
    "title": "Ref Special Stows",
    "description": "Tracks special stowage requirements"
  },
  "ref_state": {
    "title": "Ref State",
    "description": "Defines states"
  },
  "ref_tran_cancel_reasons": {
    "title": "Ref Tran Cancel Reasons",
    "description": "Records reasons for transaction cancellations"
  },
  "ref_unloc_code": {
    "title": "Ref Unloc Code",
    "description": "Defines UN/LOC codes for locations"
  },
  "road_allowable_gate_stage_map": {
    "title": "Road Allowable Gate Stage Map",
    "description": "Tracks allowable stages for gate operations"
  },
  "road_appt_priority_group": {
    "title": "Road Appt Priority Group",
    "description": "Records priority groups for road appointments"
  },
  "road_appt_quota_rule": {
    "title": "Road Appt Quota Rule",
    "description": "Defines quota rules for road appointments"
  },
  "road_appt_quota_rule_set": {
    "title": "Road Appt Quota Rule Set",
    "description": "Manages sets of quota rules for road appointments"
  },
  "road_appt_time_slot": {
    "title": "Road Appt Time Slot",
    "description": "Records time slots for road appointments"
  },
  "road_appt_yard_block_quota": {
    "title": "Road Appt Yard Block Quota",
    "description": "Tracks quotas for yard blocks related to road appointments"
  },
  "road_ar_document_messages": {
    "title": "Road Ar Document Messages",
    "description": "Tracks messages associated with road accounts receivable documents"
  },
  "road_ar_documents": {
    "title": "Road Ar Documents",
    "description": "Records road accounts receivable documents"
  },
  "road_ar_inspection_bundles": {
    "title": "Road Ar Inspection Bundles",
    "description": "Manages bundles of inspection reports for road accounts receivable"
  },
  "road_ar_inspection_placards": {
    "title": "Road Ar Inspection Placards",
    "description": "Records placards used in road accounts receivable inspections"
  },
  "road_ar_inspections": {
    "title": "Road Ar Inspections",
    "description": "Tracks road accounts receivable inspections"
  },
  "road_ar_transaction_placards": {
    "title": "Road Ar Transaction Placards",
    "description": "Records placards used in road accounts receivable transactions"
  },
  "road_ar_truck_transactions": {
    "title": "Road Ar Truck Transactions",
    "description": "Tracks transactions involving trucks in road accounts receivable"
  },
  "road_ar_truck_visit_details": {
    "title": "Road Ar Truck Visit Details",
    "description": "Records details of truck visits related to road accounts receivable"
  },
  "road_ar_truck_visit_images": {
    "title": "Road Ar Truck Visit Images",
    "description": "Manages images associated with truck visits for road accounts receivable"
  },
  "road_chassis_profiles": {
    "title": "Road Chassis Profiles",
    "description": "Defines profiles for road chassis"
  },
  "road_console_printers": {
    "title": "Road Console Printers",
    "description": "Records information about console printers used in road operations"
  },
  "road_document_messages": {
    "title": "Road Document Messages",
    "description": "Tracks messages related to road documents"
  },
  "road_document_types": {
    "title": "Road Document Types",
    "description": "Defines types of road documents"
  },
  "road_documents": {
    "title": "Road Documents",
    "description": "Records general information about road documents"
  },
  "road_gate_appointment": {
    "title": "Road Gate Appointment",
    "description": "Manages appointments for road gate operations"
  },
  "road_gate_biz_task": {
    "title": "Road Gate Biz Task",
    "description": "Tracks business tasks related to road gate operations"
  },
  "road_gate_biz_task_param": {
    "title": "Road Gate Biz Task Param",
    "description": "Defines parameters for business tasks at road gates"
  },
  "road_gate_config_tran_type": {
    "title": "Road Gate Config Tran Type",
    "description": "Records transaction types used in road gate configurations"
  },
  "road_gate_config_tv_type": {
    "title": "Road Gate Config Tv Type",
    "description": "Tracks TV types used in road gate configurations"
  },
  "road_gate_configuration": {
    "title": "Road Gate Configuration",
    "description": "Manages configuration settings for road gates"
  },
  "road_gate_consoles": {
    "title": "Road Gate Consoles",
    "description": "Defines consoles used at road gates"
  },
  "road_gate_exchange_area_delay": {
    "title": "Road Gate Exchange Area Delay",
    "description": "Records delays in road gate exchange areas"
  },
  "road_gate_exchange_areas": {
    "title": "Road Gate Exchange Areas",
    "description": "Tracks exchange areas for road gates"
  },
  "road_gate_lane_printers": {
    "title": "Road Gate Lane Printers",
    "description": "Manages printers associated with lanes at road gates"
  },
  "road_gate_lanes": {
    "title": "Road Gate Lanes",
    "description": "Records lanes at road gates"
  },
  "road_gate_relay_facilities": {
    "title": "Road Gate Relay Facilities",
    "description": "Defines relay facilities used at road gates"
  },
  "road_gate_stage_base_type": {
    "title": "Road Gate Stage Base Type",
    "description": "Tracks base types for stages at road gates"
  },
  "road_gate_stages": {
    "title": "Road Gate Stages",
    "description": "Manages stages in road gate operations"
  },
  "road_gate_xch_areas": {
    "title": "Road Gate Xch Areas",
    "description": "Records exchange areas at road gates"
  },
  "road_gate_yard_blocks": {
    "title": "Road Gate Yard Blocks",
    "description": "Tracks yard blocks associated with road gates"
  },
  "road_gate_yards": {
    "title": "Road Gate Yards",
    "description": "Defines yards associated with road gates"
  },
  "road_gates": {
    "title": "Road Gates",
    "description": "Records information about road gates"
  },
  "road_hardware_devices": {
    "title": "Road Hardware Devices",
    "description": "Tracks hardware devices used in road operations"
  },
  "road_inspection_bundles": {
    "title": "Road Inspection Bundles",
    "description": "Manages bundles of inspection reports for road operations"
  },
  "road_inspection_placard_map": {
    "title": "Road Inspection Placard Map",
    "description": "Records mappings of placards used in road inspections"
  },
  "road_inspections": {
    "title": "Road Inspections",
    "description": "Tracks inspections in road operations"
  },
  "road_lanes": {
    "title": "Road Lanes",
    "description": "Records information about lanes in road operations"
  },
  "road_line_gate_restrictions": {
    "title": "Road Line Gate Restrictions",
    "description": "Defines restrictions on lines at road gates"
  },
  "road_scan_chassis": {
    "title": "Road Scan Chassis",
    "description": "Manages scanned information related to road chassis"
  },
  "road_scan_container_placards": {
    "title": "Road Scan Container Placards",
    "description": "Tracks placards on scanned road containers"
  },
  "road_scan_containers": {
    "title": "Road Scan Containers",
    "description": "Records scanned information about road containers"
  },
  "road_scan_images": {
    "title": "Road Scan Images",
    "description": "Manages images obtained from road scans"
  },
  "road_scan_sets": {
    "title": "Road Scan Sets",
    "description": "Defines sets of road scans"
  },
  "road_transaction_placards": {
    "title": "Road Transaction Placards",
    "description": "Records placards associated with road transactions"
  },
  "road_trkc_gate_priority_group": {
    "title": "Road Trkc Gate Priority Group",
    "description": "Tracks priority groups for TRKC (Truck and Container) gate operations"
  },
  "road_truck_actions": {
    "title": "Road Truck Actions",
    "description": "Manages actions performed with road trucks"
  },
  "road_truck_company_drivers": {
    "title": "Road Truck Company Drivers",
    "description": "Records drivers for road trucking companies"
  },
  "road_truck_drivers": {
    "title": "Road Truck Drivers",
    "description": "Tracks information about individual road truck drivers"
  },
  "road_truck_transaction_bundles": {
    "title": "Road Truck Transaction Bundles",
    "description": "Records bundles of transactions related to road trucks"
  },
  "road_truck_transaction_crglots": {
    "title": "Road Truck Transaction Crglots",
    "description": "Tracks cargo lots in road truck transactions"
  },
  "road_truck_transaction_stages": {
    "title": "Road Truck Transaction Stages",
    "description": "Defines stages in road truck transactions"
  },
  "road_truck_transactions": {
    "title": "Road Truck Transactions",
    "description": "Records transactions involving road trucks"
  },
  "road_truck_visit_appt": {
    "title": "Road Truck Visit Appt",
    "description": "Tracks appointments for road truck visits"
  },
  "road_truck_visit_details": {
    "title": "Road Truck Visit Details",
    "description": "Records details of visits by road trucks"
  },
  "road_truck_visit_images": {
    "title": "Road Truck Visit Images",
    "description": "Manages images associated with road truck visits"
  },
  "road_truck_visit_stages": {
    "title": "Road Truck Visit Stages",
    "description": "Defines stages in road truck visits"
  },
  "road_truck_visit_stats": {
    "title": "Road Truck Visit Stats",
    "description": "Tracks statistics related to road truck visits"
  },
  "road_trucking_companies": {
    "title": "Road Trucking Companies",
    "description": "Records information about companies involved in road trucking"
  },
  "road_trucking_company_lines": {
    "title": "Road Trucking Company Lines",
    "description": "Tracks lines of business for road trucking companies"
  },
  "road_trucking_company_restrict": {
    "title": "Road Trucking Company Restrict",
    "description": "Defines restrictions for road trucking companies"
  },
  "road_trucks": {
    "title": "Road Trucks",
    "description": "Records general information about road trucks"
  },
  "road_xch_area_delay": {
    "title": "Road Xch Area Delay",
    "description": "Tracks delays within road exchange areas"
  },
  "saved_predicate": {
    "title": "Saved Predicate",
    "description": "Records saved database predicates (conditions) for querying"
  },
  "saved_query": {
    "title": "Saved Query",
    "description": "Stores queries that have been previously saved"
  },
  "sec_authentication_history": {
    "title": "Sec Authentication History",
    "description": "Logs authentication events for security monitoring"
  },
  "sec_ipwhitelist": {
    "title": "Sec Ipwhitelist",
    "description": "Manages IP addresses that are whitelisted for access"
  },
  "sec_persistent_login": {
    "title": "Sec Persistent Login",
    "description": "Tracks persistent login sessions"
  },
  "sec_role": {
    "title": "Sec Role",
    "description": "Defines roles within the system"
  },
  "sec_role_priv_map": {
    "title": "Sec Role Priv Map",
    "description": "Maps roles to their associated privileges"
  },
  "sec_user_auth_profile": {
    "title": "Sec User Auth Profile",
    "description": "Stores user authentication profiles"
  },
  "sec_user_bundle_map": {
    "title": "Sec User Bundle Map",
    "description": "Links users to bundles of permissions or features"
  },
  "sec_user_group_map": {
    "title": "Sec User Group Map",
    "description": "Maps users to groups"
  },
  "sec_user_role_map": {
    "title": "Sec User Role Map",
    "description": "Associates users with their respective roles"
  },
  "SessionInfo": {
    "title": "Sessioninfo",
    "description": "Records session information"
  },
  "ship_bin_cntr_length": {
    "title": "Ship Bin Cntr Length",
    "description": "Defines container lengths for shipping bins"
  },
  "snx_job_definition": {
    "title": "Snx Job Definition",
    "description": "Manages job definitions for system tasks"
  },
  "spatial_bin_ancestors": {
    "title": "Spatial Bin Ancestors",
    "description": "Tracks hierarchical relationships between spatial bins"
  },
  "spatial_bin_contexts": {
    "title": "Spatial Bin Contexts",
    "description": "Records contexts for spatial bins"
  },
  "spatial_bin_name_tables": {
    "title": "Spatial Bin Name Tables",
    "description": "Defines tables for bin names in spatial contexts"
  },
  "spatial_bin_names": {
    "title": "Spatial Bin Names",
    "description": "Stores names assigned to spatial bins"
  },
  "spatial_bin_types": {
    "title": "Spatial Bin Types",
    "description": "Categorizes types of spatial bins"
  },
  "spatial_bins": {
    "title": "Spatial Bins",
    "description": "Records information about spatial bins"
  },
  "spatial_graph_paths": {
    "title": "Spatial Graph Paths",
    "description": "Tracks paths in spatial graphs"
  },
  "spatial_graph_vertices": {
    "title": "Spatial Graph Vertices",
    "description": "Records vertices in spatial graphs"
  },
  "spatial_graphs": {
    "title": "Spatial Graphs",
    "description": "Defines spatial graphs"
  },
  "srv_ar_event": {
    "title": "Srv Ar Event",
    "description": "Tracks events related to accounts receivable services"
  },
  "srv_ar_flags": {
    "title": "Srv Ar Flags",
    "description": "Manages flags used in accounts receivable services"
  },
  "srv_auto_update_field": {
    "title": "Srv Auto Update Field",
    "description": "Records fields subject to automatic updates"
  },
  "srv_auto_update_flags": {
    "title": "Srv Auto Update Flags",
    "description": "Defines flags for automatic updates"
  },
  "srv_auto_update_rules": {
    "title": "Srv Auto Update Rules",
    "description": "Tracks rules governing automatic updates"
  },
  "srv_event": {
    "title": "Srv Event",
    "description": "Logs general service events"
  },
  "srv_event_effect": {
    "title": "Srv Event Effect",
    "description": "Records effects of service events"
  },
  "srv_event_field_changes": {
    "title": "Srv Event Field Changes",
    "description": "Tracks changes to fields triggered by service events"
  },
  "srv_event_types": {
    "title": "Srv Event Types",
    "description": "Defines types of service events"
  },
  "srv_flag_types": {
    "title": "Srv Flag Types",
    "description": "Categorizes types of service flags"
  },
  "srv_flags": {
    "title": "Srv Flags",
    "description": "Records general service flags"
  },
  "srv_hold_perm_view": {
    "title": "Srv Hold Perm View",
    "description": "Manages views related to permissions held"
  },
  "srv_notice_requests": {
    "title": "Srv Notice Requests",
    "description": "Tracks requests for service notices"
  },
  "srv_rules": {
    "title": "Srv Rules",
    "description": "Defines rules for service operations"
  },
  "srv_vetos": {
    "title": "Srv Vetos",
    "description": "Records vetoes in service operations"
  },
  "sysdiagrams": {
    "title": "Sysdiagrams",
    "description": "Manages system diagrams"
  },
  "user_dashboard_layout": {
    "title": "User Dashboard Layout",
    "description": "Stores layout configurations for user dashboards"
  },
  "user_dashgadget_props": {
    "title": "User Dashgadget Props",
    "description": "Records properties of gadgets used in user dashboards"
  },
  "user_option": {
    "title": "User Option",
    "description": "Tracks user options and preferences"
  },
  "user_option_favorite_nodes": {
    "title": "User Option Favorite Nodes",
    "description": "Records favorite nodes selected by users"
  },
  "user_option_form_filter_prefs": {
    "title": "User Option Form Filter Prefs",
    "description": "Manages user preferences for form filters"
  },
  "user_option_open_nodes": {
    "title": "User Option Open Nodes",
    "description": "Tracks nodes that users have opened"
  },
  "user_option_view_bounds": {
    "title": "User Option View Bounds",
    "description": "Records bounds for user views"
  },
  "VariableInstanceLog": {
    "title": "Variableinstancelog",
    "description": "Logs variable instances"
  },
  "vsl_ar_late_arrivals": {
    "title": "Vsl Ar Late Arrivals",
    "description": "Tracks late arrivals of vessels related to accounts receivable"
  },
  "vsl_ar_line_discharge_list": {
    "title": "Vsl Ar Line Discharge List",
    "description": "Records lists of line discharges for accounts receivable vessels"
  },
  "vsl_ar_line_loadlist": {
    "title": "Vsl Ar Line Loadlist",
    "description": "Manages lists of line loads for accounts receivable vessels"
  },
  "vsl_ar_vessel_berthings": {
    "title": "Vsl Ar Vessel Berthings",
    "description": "Tracks vessel berthings related to accounts receivable"
  },
  "vsl_ar_vessel_visit_details": {
    "title": "Vsl Ar Vessel Visit Details",
    "description": "Records details of vessel visits related to accounts receivable"
  },
  "vsl_ar_vessel_visit_lines": {
    "title": "Vsl Ar Vessel Visit Lines",
    "description": "Tracks lines associated with vessel visits in accounts receivable"
  },
  "vsl_bays": {
    "title": "Vsl Bays",
    "description": "Defines bays for vessel operations"
  },
  "vsl_crane_statistics": {
    "title": "Vsl Crane Statistics",
    "description": "Records statistics for cranes used in vessel operations"
  },
  "vsl_crane_statistics_delays": {
    "title": "Vsl Crane Statistics Delays",
    "description": "Tracks delays in crane operations"
  },
  "vsl_late_arrivals": {
    "title": "Vsl Late Arrivals",
    "description": "Manages records of late arrivals for vessels"
  },
  "vsl_lids": {
    "title": "Vsl Lids",
    "description": "Defines identifiers for vessels"
  },
  "vsl_line_discharge_list": {
    "title": "Vsl Line Discharge List",
    "description": "Records discharge lists for vessel lines"
  },
  "vsl_line_loadlist": {
    "title": "Vsl Line Loadlist",
    "description": "Manages load lists for vessel lines"
  },
  "vsl_line_statistics": {
    "title": "Vsl Line Statistics",
    "description": "Tracks statistics for vessel lines"
  },
  "vsl_vessel_berthings": {
    "title": "Vsl Vessel Berthings",
    "description": "Records berthings for vessels"
  },
  "vsl_vessel_classes": {
    "title": "Vsl Vessel Classes",
    "description": "Defines vessel classes"
  },
  "vsl_vessel_visit_details": {
    "title": "Vsl Vessel Visit Details",
    "description": "Tracks details of vessel visits"
  },
  "vsl_vessel_visit_lines": {
    "title": "Vsl Vessel Visit Lines",
    "description": "Records lines associated with vessel visits"
  },
  "vsl_vessels": {
    "title": "Vsl Vessels",
    "description": "Manages general information about vessels"
  },
  "wfor_group": {
    "title": "Wfor Group",
    "description": "Defines workflow groups"
  },
  "wfor_group_resource": {
    "title": "Wfor Group Resource",
    "description": "Tracks resources associated with workflow groups"
  },
  "wfor_process_instance": {
    "title": "Wfor Process Instance",
    "description": "Records instances of workflow processes"
  },
  "wfor_resource": {
    "title": "Wfor Resource",
    "description": "Manages resources used in workflows"
  },
  "wfor_resource_compiled": {
    "title": "Wfor Resource Compiled",
    "description": "Tracks compiled resources for workflows"
  },
  "WorkItemInfo": {
    "title": "Workiteminfo",
    "description": "Records information about work items"
  },
  "xps_abbloadrecord": {
    "title": "Xps Abbloadrecord",
    "description": "Records ABB load details"
  },
  "xps_ag": {
    "title": "Xps Ag",
    "description": "Tracks aggregate data"
  },
  "xps_allocation_filt": {
    "title": "Xps Allocation Filt",
    "description": "Manages allocation filters"
  },
  "xps_allocation_filt_fields": {
    "title": "Xps Allocation Filt Fields",
    "description": "Records fields used in allocation filters"
  },
  "xps_allocation_filt_weights": {
    "title": "Xps Allocation Filt Weights",
    "description": "Stores weights associated with allocation filters"
  },
  "xps_appcolorpaletteinfo": {
    "title": "Xps Appcolorpaletteinfo",
    "description": "Defines color palettes for application themes"
  },
  "xps_ar": {
    "title": "Xps Ar",
    "description": "Tracks accounts receivable data"
  },
  "xps_autostow_filt": {
    "title": "Xps Autostow Filt",
    "description": "Manages auto-stow filters"
  },
  "xps_autostow_filt_fields": {
    "title": "Xps Autostow Filt Fields",
    "description": "Records fields used in auto-stow filters"
  },
  "xps_autostow_filt_weights": {
    "title": "Xps Autostow Filt Weights",
    "description": "Stores weights associated with auto-stow filters"
  },
  "xps_berthactivity": {
    "title": "Xps Berthactivity",
    "description": "Tracks berth activities"
  },
  "xps_berthalloc": {
    "title": "Xps Berthalloc",
    "description": "Manages berth allocations"
  },
  "xps_berthalloc_lineoperators": {
    "title": "Xps Berthalloc Lineoperators",
    "description": "Records line operators associated with berth allocations"
  },
  "xps_berthalloc_vesselclasses": {
    "title": "Xps Berthalloc Vesselclasses",
    "description": "Tracks vessel classes related to berth allocations"
  },
  "xps_blockdispatchoptions": {
    "title": "Xps Blockdispatchoptions",
    "description": "Defines options for block dispatching"
  },
  "xps_cargeometry": {
    "title": "Xps Cargeometry",
    "description": "Records cargo geometry details"
  },
  "xps_cargeometry_doorisback": {
    "title": "Xps Cargeometry Doorisback",
    "description": "Tracks cargo geometry with respect to door positioning"
  },
  "xps_cargeometry_platformlabel": {
    "title": "Xps Cargeometry Platformlabel",
    "description": "Defines labels for cargo platforms"
  },
  "xps_cartype": {
    "title": "Xps Cartype",
    "description": "Manages types of cargo"
  },
  "xps_cartype_platforminfo": {
    "title": "Xps Cartype Platforminfo",
    "description": "Records platform information for different cargo types"
  },
  "xps_che": {
    "title": "Xps Che",
    "description": "Tracks CHE (Container Handling Equipment) data"
  },
  "xps_che_filt": {
    "title": "Xps Che Filt",
    "description": "Manages filters for CHE data"
  },
  "xps_che_filt_fields": {
    "title": "Xps Che Filt Fields",
    "description": "Records fields used in CHE filters"
  },
  "xps_che_filt_weights": {
    "title": "Xps Che Filt Weights",
    "description": "Stores weights associated with CHE filters"
  },
  "xps_chezone": {
    "title": "Xps Chezone",
    "description": "Defines CHE zones"
  },
  "xps_craneactivity": {
    "title": "Xps Craneactivity",
    "description": "Tracks crane activities"
  },
  "xps_craneshift": {
    "title": "Xps Craneshift",
    "description": "Records crane shift details"
  },
  "xps_deliveryrange": {
    "title": "Xps Deliveryrange",
    "description": "Defines delivery ranges for cargo"
  },
  "xps_discharge_map": {
    "title": "Xps Discharge Map",
    "description": "Tracks discharge mapping"
  },
  "xps_dischargehub_map": {
    "title": "Xps Dischargehub Map",
    "description": "Records hub mapping for discharges"
  },
  "xps_ecalarm": {
    "title": "Xps Ecalarm",
    "description": "Manages alarms related to EC (Emergency Call) systems"
  },
  "xps_ecevent": {
    "title": "Xps Ecevent",
    "description": "Tracks EC events"
  },
  "xps_ecuser": {
    "title": "Xps Ecuser",
    "description": "Records users related to EC systems"
  },
  "xps_ecuser_programnames": {
    "title": "Xps Ecuser Programnames",
    "description": "Defines program names associated with EC users"
  },
  "xps_ediinterchange": {
    "title": "Xps Ediinterchange",
    "description": "Tracks EDI (Electronic Data Interchange) interchanges"
  },
  "xps_edipartner": {
    "title": "Xps Edipartner",
    "description": "Records EDI partners"
  },
  "xps_emtsel_filt": {
    "title": "Xps Emtsel Filt",
    "description": "Manages filters for EM (Equipment Management) selection"
  },
  "xps_emtsel_filt_fields": {
    "title": "Xps Emtsel Filt Fields",
    "description": "Records fields used in EM selection filters"
  },
  "xps_emtsel_filt_weights": {
    "title": "Xps Emtsel Filt Weights",
    "description": "Stores weights associated with EM selection filters"
  },
  "xps_equiprequest_filt": {
    "title": "Xps Equiprequest Filt",
    "description": "Manages filters for equipment requests"
  },
  "xps_equiprequest_filt_fields": {
    "title": "Xps Equiprequest Filt Fields",
    "description": "Records fields used in equipment request filters"
  },
  "xps_equiprequest_filt_weights": {
    "title": "Xps Equiprequest Filt Weights",
    "description": "Stores weights associated with equipment request filters"
  },
  "xps_group": {
    "title": "Xps Group",
    "description": "Defines groups within the system"
  },
  "xps_group_map": {
    "title": "Xps Group Map",
    "description": "Tracks mappings between groups and resources"
  },
  "xps_group_privileges": {
    "title": "Xps Group Privileges",
    "description": "Records privileges assigned to groups"
  },
  "xps_groupdest_map": {
    "title": "Xps Groupdest Map",
    "description": "Manages destination mappings for groups"
  },
  "xps_linegroup_map": {
    "title": "Xps Linegroup Map",
    "description": "Tracks mappings between line groups and resources"
  },
  "xps_lineoperator_map": {
    "title": "Xps Lineoperator Map",
    "description": "Records mappings between line operators and lines"
  },
  "xps_lineport_map": {
    "title": "Xps Lineport Map",
    "description": "Defines mappings between lines and ports"
  },
  "xps_listviewformat": {
    "title": "Xps Listviewformat",
    "description": "Manages formats for list views"
  },
  "xps_listviewformat_fields": {
    "title": "Xps Listviewformat Fields",
    "description": "Records fields used in list view formats"
  },
  "xps_localhub": {
    "title": "Xps Localhub",
    "description": "Tracks local hub information"
  },
  "xps_menuhotkey": {
    "title": "Xps Menuhotkey",
    "description": "Defines hotkeys for menu items"
  },
  "xps_movekindallowed": {
    "title": "Xps Movekindallowed",
    "description": "Manages allowed move types"
  },
  "xps_nonconcargo": {
    "title": "Xps Nonconcargo",
    "description": "Records non-conforming cargo details"
  },
  "xps_nonconcargo_currentslots": {
    "title": "Xps Nonconcargo Currentslots",
    "description": "Tracks current slots for non-conforming cargo"
  },
  "xps_nonconcargo_plannedslots": {
    "title": "Xps Nonconcargo Plannedslots",
    "description": "Records planned slots for non-conforming cargo"
  },
  "xps_object": {
    "title": "Xps Object",
    "description": "Defines general objects within the system"
  },
  "xps_pdsalarm": {
    "title": "Xps Pdsalarm",
    "description": "Tracks alarms related to PDS (Product Distribution Systems)"
  },
  "xps_pod_map": {
    "title": "Xps Pod Map",
    "description": "Manages POD (Proof of Delivery) mappings"
  },
  "xps_pointofwork": {
    "title": "Xps Pointofwork",
    "description": "Records points of work"
  },
  "xps_pol_map": {
    "title": "Xps Pol Map",
    "description": "Tracks POL (Port of Loading) mappings"
  },
  "xps_pool": {
    "title": "Xps Pool",
    "description": "Defines pools within the system"
  },
  "xps_prioritycode_map": {
    "title": "Xps Prioritycode Map",
    "description": "Records priority code mappings"
  },
  "xps_quota_filt": {
    "title": "Xps Quota Filt",
    "description": "Manages filters for quota allocations"
  },
  "xps_quota_filt_fields": {
    "title": "Xps Quota Filt Fields",
    "description": "Records fields used in quota filters"
  },
  "xps_quota_filt_weights": {
    "title": "Xps Quota Filt Weights",
    "description": "Stores weights associated with quota filters"
  },
  "xps_railcardestblock_map": {
    "title": "Xps Railcardestblock Map",
    "description": "Tracks railcar destination block mappings"
  },
  "xps_railstate": {
    "title": "Xps Railstate",
    "description": "Records rail state details"
  },
  "xps_railstate_caroffsets": {
    "title": "Xps Railstate Caroffsets",
    "description": "Defines offsets for railcars"
  },
  "xps_railstate_trackstates": {
    "title": "Xps Railstate Trackstates",
    "description": "Tracks track states"
  },
  "xps_recapviewformat": {
    "title": "Xps Recapviewformat",
    "description": "Manages formats for recap views"
  },
  "xps_recapviewformat_fields": {
    "title": "Xps Recapviewformat Fields",
    "description": "Records fields used in recap view formats"
  },
  "xps_reportconfiguration": {
    "title": "Xps Reportconfiguration",
    "description": "Tracks configurations for reports"
  },
  "xps_role": {
    "title": "Xps Role",
    "description": "Defines roles within the system"
  },
  "xps_rptpkg": {
    "title": "Xps Rptpkg",
    "description": "Manages report packages"
  },
  "xps_rptpkg_configrefs": {
    "title": "Xps Rptpkg Configrefs",
    "description": "Records configuration references for report packages"
  },
  "xps_sectionfactor_filt": {
    "title": "Xps Sectionfactor Filt",
    "description": "Manages filters for section factors"
  },
  "xps_sectionfactor_filt_fields": {
    "title": "Xps Sectionfactor Filt Fields",
    "description": "Records fields used in section factor filters"
  },
  "xps_sectionfactor_filt_weights": {
    "title": "Xps Sectionfactor Filt Weights",
    "description": "Stores weights associated with section factor filters"
  },
  "xps_service_map": {
    "title": "Xps Service Map",
    "description": "Tracks service mappings"
  },
  "xps_session": {
    "title": "Xps Session",
    "description": "Records session information"
  },
  "xps_sharedparameters": {
    "title": "Xps Sharedparameters",
    "description": "Defines shared parameters for system configurations"
  },
  "xps_sharedparameters_params": {
    "title": "Xps Sharedparameters Params",
    "description": "Records parameters for shared settings"
  },
  "xps_stacknote": {
    "title": "Xps Stacknote",
    "description": "Tracks stack notes"
  },
  "xps_stackstatus": {
    "title": "Xps Stackstatus",
    "description": "Records statuses for stacks"
  },
  "xps_stowfactor_filt": {
    "title": "Xps Stowfactor Filt",
    "description": "Manages filters for stowage factors"
  },
  "xps_stowfactor_filt_fields": {
    "title": "Xps Stowfactor Filt Fields",
    "description": "Records fields used in stowage factor filters"
  },
  "xps_stowfactor_filt_weights": {
    "title": "Xps Stowfactor Filt Weights",
    "description": "Stores weights associated with stowage factor filters"
  },
  "xps_trainmax_map": {
    "title": "Xps Trainmax Map",
    "description": "Tracks maximum train configurations"
  },
  "xps_trainservice_map": {
    "title": "Xps Trainservice Map",
    "description": "Records train service mappings"
  },
  "xps_transferpoint": {
    "title": "Xps Transferpoint",
    "description": "Defines transfer points"
  },
  "xps_transportitem": {
    "title": "Xps Transportitem",
    "description": "Tracks transport items"
  },
  "xps_transportorder": {
    "title": "Xps Transportorder",
    "description": "Records transport orders"
  },
  "xps_transshipment": {
    "title": "Xps Transshipment",
    "description": "Manages transshipment records"
  },
  "xps_trip": {
    "title": "Xps Trip",
    "description": "Tracks trip details"
  },
  "xps_truckdriver": {
    "title": "Xps Truckdriver",
    "description": "Records truck driver details"
  },
  "xps_user": {
    "title": "Xps User",
    "description": "Manages user accounts"
  },
  "xps_user_filt": {
    "title": "Xps User Filt",
    "description": "Manages user filters"
  },
  "xps_user_filt_fields": {
    "title": "Xps User Filt Fields",
    "description": "Records fields used in user filters"
  },
  "xps_user_filt_weights": {
    "title": "Xps User Filt Weights",
    "description": "Stores weights associated with user filters"
  },
  "xps_validationconfig": {
    "title": "Xps Validationconfig",
    "description": "Tracks validation configurations"
  },
  "xps_weightgroup": {
    "title": "Xps Weightgroup",
    "description": "Defines weight groups"
  },
  "xps_weightgroup_weightgroup": {
    "title": "Xps Weightgroup Weightgroup",
    "description": "Records relationships between weight groups"
  },
  "xps_wheeledmt_filt": {
    "title": "Xps Wheeledmt Filt",
    "description": "Manages filters for wheeled equipment"
  },
  "xps_wheeledmt_filt_fields": {
    "title": "Xps Wheeledmt Filt Fields",
    "description": "Records fields used in wheeled equipment filters"
  },
  "xps_wheeledmt_filt_weights": {
    "title": "Xps Wheeledmt Filt Weights",
    "description": "Stores weights associated with wheeled equipment filters"
  },
  "xps_wherenetalarm": {
    "title": "Xps Wherenetalarm",
    "description": "Tracks alarms for non-ET (Non-Estimated Time) scenarios"
  },
  "xps_workassignment": {
    "title": "Xps Workassignment",
    "description": "Records work assignments"
  },
  "xps_yardmove_filt": {
    "title": "Xps Yardmove Filt",
    "description": "Manages filters for yard moves"
  },
  "xps_yardmove_filt_fields": {
    "title": "Xps Yardmove Filt Fields",
    "description": "Records fields used in yard move filters"
  },
  "xps_yardmove_filt_weights": {
    "title": "Xps Yardmove Filt Weights",
    "description": "Stores weights associated with yard move filters"
  },
  "xps_ymfrange": {
    "title": "Xps Ymfrange",
    "description": "Tracks YMF (Yard Management Facility) ranges"
  },
  "yard_adj_block_locs": {
    "title": "Yard Adj Block Locs",
    "description": "Records block locations for yard adjustments"
  },
  "yard_berth_markers": {
    "title": "Yard Berth Markers",
    "description": "Defines markers for yard berths"
  },
  "yard_berth_models": {
    "title": "Yard Berth Models",
    "description": "Tracks models for yard berths"
  },
  "yard_berth_user_ranges": {
    "title": "Yard Berth User Ranges",
    "description": "Manages user-defined ranges for yard berths"
  },
  "yard_bin_paths": {
    "title": "Yard Bin Paths",
    "description": "Records paths for yard bins"
  },
  "yard_map_reference_points": {
    "title": "Yard Map Reference Points",
    "description": "Tracks reference points on yard maps"
  },
  "yard_prestage_groups": {
    "title": "Yard Prestage Groups",
    "description": "Defines pre-stage groups for yard operations"
  },
  "yard_prestage_locations": {
    "title": "Yard Prestage Locations",
    "description": "Records locations for pre-staging in yards"
  },
  "yard_rfr_mon_ranges": {
    "title": "Yard Rfr Mon Ranges",
    "description": "Tracks RFR (Reference) monitoring ranges in yards"
  },
  "yard_xfr_block_assoc": {
    "title": "Yard Xfr Block Assoc",
    "description": "Records associations between yard blocks and transfers"
  },
};
